module.exports = __webpack_public_path__ + "img/star-small.111ac09c.svg";